import { useSelector } from '@/utils/redux';
import { useLocation } from '@/utils/router';

/**
 * 路由权限验证hooks、判断有没有使用权限
 * @returns {boolean}
 */
export function useRoutePermissions() {
  const { flatPermissionMenus = [] } = useSelector(state => state.user.userInfo);
  const { pathname } = useLocation();
  const secondPath = pathname.split('/').slice(0, 4).join('/');
  return flatPermissionMenus.some(v => ~v.path.indexOf(secondPath));

}

/**
 * 按钮权限验证hooks、判断有没有使用权限
 * @returns {boolean}
 */
export function useFuncPermission() {
  const { id } = useSelector(state => state.user.userInfo);
  return MANAGE_ID.some(v => v === id);
}

const MANAGE_ID = [1, 49];

/**
 * sideBar 展开收起时的状态及对应的内容区域宽高
 * @returns {{sideBarWidth, miniBarWidth, headerHeight, miniBar}}
 */
export function userLayoutConfig() {
  const { miniBarWidth, sideBarWidth, headerHeight, miniBar, defaultHidden, hasFixBottom, hideSideBarPages, containerPadding } = useSelector(state => state.projectSetting);
  return {
    miniBarWidth,
    sideBarWidth,
    headerHeight,
    miniBar,
    defaultHidden,
    hasFixBottom,
    hideSideBarPages,
    containerPadding
  };
}
